import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=auth
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    // Telegram WebApp auto-login.
    // If we're inside Telegram (initData present), ALWAYS authenticate via /auth/telegram —
    // never trust an existing localStorage token, because it could belong to a different
    // account (email login, or previous Telegram user on a shared device).
    const tg = window.Telegram?.WebApp;
    if (tg && tg.initData) {
      try {
        tg.ready();
        tg.expand();
        tg.disableVerticalSwipes?.();
      } catch {}
      api.post("/auth/telegram", { init_data: tg.initData })
        .then((r) => {
          localStorage.setItem("token", r.data.token);
          setUser(r.data.user);
          setBalance(r.data.user.balance);
        })
        .catch(() => setUser(false));
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); setBalance(r.data.balance); })
      .catch(() => { localStorage.removeItem("token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    setBalance(data.user.balance);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    setBalance(data.user.balance);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, balance, setBalance, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
